import { toast } from "react-toastify";

export const loadingToast = (msg = "Por favor, espere...") => {
  const id = toast.loading(msg);
  return id;
};

export const updateToast = (id, type, msg) => {
  toast.update(id, {
    render: msg,
    type: type,
    isLoading: false,
    position: "top-center",
    autoClose: 3000,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
export const dispatchErrorMessage = (id, res, msgDefault) => {
  let msg = msgDefault;
  if (res?.[1] && res[1].data) {
    if (res[1].data.data) {
      msg = res[1].data.data.message;
    } else if (res[1].data.message) {
      msg = res[1].data.message;
    }
  }
  if (id !== null && id !== undefined) {
    updateToast(id, "error", msg, { delay: 100 });
    return;
  }

  toast.error(msg, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};

export const showInfoToast = (
  msg = "Debes completar todos los campos obligatorios."
) => {
  toast.info(msg, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
export const showErrorToast = (res, msgDefault = "Error") => {
  let msg = msgDefault;
  if (res[1] && res[1].data) {
    if (res[1].data.data) {
      msg = res[1].data.data.message;
    } else if (res[1].data.message) {
      msg = res[1].data.message;
    }
  }
  toast.error(msg, {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });
};
